import createImageIcon from './createImageIcon';
import path from './ondemand-logo.png';

export default createImageIcon({displayName: 'OndemandLogo', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/OndemandLogo.js